import styled from 'styled-components';
import { Box } from '@mui/material';import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
export const ModelWrapper = styled(Dialog)`
.customDialogTitle {
    background-color: #1b4a83;
    text-align: center;
    color: #fff;
         }
         .customDialog
         {
            text-align: center;
            color:#000;
            img{
               display: block;
               margin: 30px auto; /* Center the image horizontally */
               max-width: 100px; /* Set the desired max width for the image */
           }
          
          
         }
         .confirmButton{
            background-color: #1b4a83;
         }
         .rightButton {
            margin-left: auto; /* Push the button to the right side */
          }
     
`;

